import React, { useState } from "react";
import "./Template_2.css";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import DefaultData from "../../CompanyData/DefaultData";

const initialFieldValues = {
  name: "",
  email: "",
  phoneNumber: "",
  comments: "",
  type: "Holiday",
};

const CheckmarkIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="#0d6efd" strokeWidth="2" />
    <path
      d="M7.5 12.5L10.5 15.5L16.5 9.5"
      stroke="#0d6efd"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Template_2_EnquiryPopup = ({ packageDetails, onClose }) => {
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const validate = () => {
    let tempErrors = {};
    if (!values.name) tempErrors.name = "Name is required.";
    if (!values.phoneNumber)
      tempErrors.phoneNumber = "Phone number is required.";
    if (!values.email) {
      tempErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      tempErrors.email = "Email is not valid.";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const packageId =
      packageDetails?.packageId || "00000000-0000-0000-0000-000000000000";
    const companyId = DefaultData.DEFAULTCOMPANYID;

    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("name", values.name);
    formData.append("email", values.email);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("packageId", packageId);
    formData.append("companyId", companyId);
    formData.append("type", values.type);
    if (values.comments) {
      formData.append("comments", values.comments);
    }

    try {
      const response = await apiService.post(
        config.CREATEPACKAGEENQUIRY,
        formData
      );
      if (response) {
        setIsSubmitted(true);
      }
    } catch (error) {
      console.error("Enquiry submission failed:", error);
      setErrors({ api: "Failed to submit enquiry. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };

  const ThankYouView = () => {
    const destinationName =
      packageDetails?.destination?.destinationName || "your destination";
    const travelDate = packageDetails?.startedDate
      ? new Date(packageDetails.startedDate).toLocaleString("en-US", {
          month: "short",
          year: "numeric",
        })
      : "your travel date";

    return (
      <div className="thank-you text-center">
        <h2 className="fw-bold mb-3">Thank You</h2>
        <p className="lead mb-2">
          Our Holiday Expert will shortly reach out to you with our best
          quotations on
        </p>
        <p className="lead fw-bold mb-4">{values.phoneNumber}</p>
        <div className="thankyou-box">
          <div className="d-flex align-items-center">
            <div className="flex-grow-1 text-start">
              <h6 className="fw-bold mb-0">Request Received</h6>
              <span className="text-muted">{`${destinationName} - ${travelDate}`}</span>
            </div>
            <div className="ms-4">
              <CheckmarkIcon />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="Template_2 enquiry-popup">
      <div className="Template_2 enquiry-form">
        <button className="Template_2 close-btn" onClick={onClose}>
          &times;
        </button>

        {!isSubmitted ? (
          <>
            <h3>
              Enquire About{" "}
              <span>{packageDetails?.packageName || "Package"}</span>
            </h3>
            <form onSubmit={handleSubmit}>
              <div className="Template_2 form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  required
                />
                {errors.name && <p className="text-danger">{errors.name}</p>}
              </div>

              <div className="Template_2 form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  required
                />
                {errors.email && <p className="text-danger">{errors.email}</p>}
              </div>

              <div className="Template_2 form-group">
                <label htmlFor="phoneNumber">Phone Number</label>
                <input
                  type="tel"
                  id="phoneNumber"
                  name="phoneNumber"
                  value={values.phoneNumber}
                  onChange={handleChange}
                  required
                />
                {errors.phoneNumber && (
                  <p className="text-danger">{errors.phoneNumber}</p>
                )}
              </div>

              <div className="Template_2 form-group">
                <label htmlFor="comments">Comments</label>
                <textarea
                  id="comments"
                  name="comments"
                  rows="3"
                  value={values.comments}
                  onChange={handleChange}
                />
              </div>

              {errors.api && (
                <p className="text-danger text-center">{errors.api}</p>
              )}

              <button
                type="submit"
                className="Template_2 submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit Enquiry"}
              </button>
            </form>
          </>
        ) : (
          <ThankYouView />
        )}
      </div>
    </div>
  );
};

export default Template_2_EnquiryPopup;
